import theme from "@/theme";

export const styles = {
  sevedPost: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    backgroundColor: "#F5F5F5",
    padding: "0",
    maxHeight: "calc(100% - 100px)",
  },
  wrapper: {
    width: "100%",
    padding: "0",
    margin: "0",
  },
  container: {
    p: 2,
    backgroundColor: "#FFFFFF",
    width: "100%",
    margin: "0px",
    overflow: "auto",
    padding: "0",
  },

  header: {
    height: "80px",
    width: "100%",
    backgroundColor: "#FFFFFF",
    padding: "30px 40px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  starButton: {
    color: "#007bff",
  },
  tabsBox: {
    display: "flex",
    gap: "40px",
  },

  tabItem: (active: boolean) => ({
    cursor: "pointer",
    color: active ? theme.palette.custom.mainBlue : "#4f5b67",
    borderBottom: active ? `2px solid ${theme.palette.custom.mainBlue}` : "none",
    pb: "2px",
    fontWeight: active ? 600 : 500,
    lineHeight: "20px",
    fontFamily: "Inter",
    fontSize: "16px",
  }),
};
